module.exports = __webpack_public_path__ + "static/media/sticker-1.bf8be540.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/CovidSocial/sticker-1.PNG
// module id = 454
// module chunks = 0